import LogoAl from '../../assets/secti_logo_2023.png';
import './styles.css';


export default function HeaderSectiDash(){
       return (
        <div className='headerSectiDash'>
            <div className='imgLogoAlDash'>
                <img src={LogoAl} alt="Estado de Alagoas — SECTI" />
            </div>

        </div>
    )
}